import { render } from "./App.vue?vue&type=template&id=af074626"
const script = {}

import "./App.vue?vue&type=style&index=0&id=af074626&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\yearchecker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__